module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('div', [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Basic-Paragraph para-style-override-10"
  }, [_vm._v("Ghost Hunter’s Guide")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Basic-Paragraph para-style-override-2"
  }, [_c('span', {
    staticClass: "char-style-override-1"
  }, [_vm._v("to")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-11"
  })]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Basic-Paragraph para-style-override-12"
  }, [_vm._v("Portland")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Basic-Paragraph para-style-override-13"
  }, [_vm._v("and the")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Basic-Paragraph para-style-override-12"
  }, [_vm._v("Oregon Coast")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Basic-Paragraph para-style-override-11a"
  }, [_vm._v("Jeff Dwyer")]), _vm._v(" "), _c('div', {
    staticClass: "frame-2a"
  }, [_c('img', {
    staticClass: "frame-3",
    staticStyle: {
      "width": "80.46875px"
    },
    attrs: {
      "alt": "PELOGO.TIF",
      "src": "Images/PELOGO_fmt.jpeg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-2"
  }, [_c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("PELICAN PUBLISHING COMPANY")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-3"
  }, [_c('span', {
    staticClass: "char-style-override-5"
  }, [_vm._v("Gretna 2015")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4521a6dd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0004.vue
// module id = 63
// module chunks = 0